import React from "react";
import { useNavigate } from "react-router-dom";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditTestimonial from "../../components/testimonials/FormAddEditTestimonial";

const CreateTestimonial = () => {
    const navigate = useNavigate();

    const handleSuccess = () => {
        navigate("/testimonials");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditTestimonial
                isEdit={false}
                currentData={null}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default CreateTestimonial;
